import { keyframes } from '@mui/material'

export const ellipsisKeyframes = keyframes`
  0%   { content: ''; }
  25%  { content: '.'; }
  50%  { content: '..'; }
  75%  { content: '...'; }
  100% { content: ''; }
`
